import React from 'react';
import LayoutAdmin from '../../layouts/admin';
import ProductDetailContent from '../../components/product_detail';



const ProductDetailPage = () => {
  return (
    <LayoutAdmin content={<ProductDetailContent/>}/>
  );
}

export default ProductDetailPage;